import React, {useState} from 'react'
import { Row, Col, Dropdown } from 'antd'
import { useNavigate } from 'react-router-dom'

const NavbarModel: React.FC = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false)
  const navigate = useNavigate();
  const onOpenChange = (open) => {
    setIsOpen(open)
  }
  const onClick = () => {
    setIsOpen(false)
  }
  const handlePage = (path) => {
    navigate(path)
    setIsOpen(false)
  }
  return (
    <Dropdown
      placement="bottomLeft"
      open={isOpen}
      onOpenChange={onOpenChange}
      // onClick={onClick}
      dropdownRender={() =>
        <div className='__dropdown-nav'>
          <Row className='nav-bar' gutter={100}>
            <Col md={7} className='nav-col'>
              <div className={`nav-title ${location.pathname === '/product/consult/0' ? 'active' : ''}`} onClick={() => handlePage('/product/consult/0')}>管理咨询</div>
              <div className='nav-desc'>价值再造·赋能可持续发展</div>
              <div className='nav-list'>
                <div className={`nav-list-block ${location.pathname === '/product/consult/1' ? 'active' : ''}`} onClick={() => handlePage('/product/consult/1')}>战略规划</div>
                <div className={`nav-list-block ${location.pathname === '/product/consult/2' ? 'active' : ''}`} onClick={() => handlePage('/product/consult/2')}>组织效能</div>
                <div className={`nav-list-block ${location.pathname === '/product/consult/3' ? 'active' : ''}`} onClick={() => handlePage('/product/consult/3')}>人才管理</div>
                <div className={`nav-list-block ${location.pathname === '/product/consult/4' ? 'active' : ''}`} onClick={() => handlePage('/product/consult/4')}>品牌营销</div>
                {/*<div className='nav-list-block'>项泽治略</div>*/}
                {/*<div className={`nav-list-block ${location.pathname === '/product/wealth' ? 'active' : ''}`} onClick={() => handlePage('/product/wealth')}>财赋+</div>*/}
                {/*<div className='nav-list-block'>知识管理局</div>*/}
              </div>
            </Col>
            <Col md={8} className='nav-col'>
              <div className={`nav-title ${location.pathname === '/product/enterprise' ? 'active' : ''}`}  onClick={() => handlePage('/product/enterprise')}>企业内训</div>
              <div className='nav-desc'>聚焦成功经验·让战略高效落地</div>
              <div className='nav-list'>
                <div className={`nav-list-block ${location.pathname === '/product/construction/1' ? 'active' : ''}`} onClick={() => handlePage('/product/construction/1')}>人才梯队建设</div>
                {/*<div className={`nav-list-block ${location.pathname === '/product/tactic' ? 'active' : ''}`} onClick={() => handlePage('/product/tactic')}>战略</div>*/}
                {/*<div className={`nav-list-block ${location.pathname === '/product/organize' ? 'active' : ''}`} onClick={() => handlePage('/product/organize')}>组织</div>*/}
                {/*<div className={`nav-list-block ${location.pathname === '/product/talents' ? 'active' : ''}`} onClick={() => handlePage('/product/talents')}>人才</div>*/}
                {/*<div className={`nav-list-block ${location.pathname === '/product/study/1' ? 'active' : ''}`} onClick={() => handlePage('/product/study/1')}>素质研学</div>*/}
                <div className={`nav-list-block ${location.pathname === '/product/visit' ? 'active' : ''}`} onClick={() => handlePage('/product/visit')}>标杆参访</div>
                <div className={`nav-list-block ${location.pathname === '/product/study/3' ? 'active' : ''}`} onClick={() => handlePage('/product/study/3')}>团建拓展</div>
                <div className={`nav-list-block ${location.pathname === '/product/study/2' ? 'active' : ''}`} onClick={() => handlePage('/product/study/2')}>人文素质研学</div>
                <div className={`nav-list-block ${location.pathname === '/product/mark' ? 'active' : ''}`} onClick={() => handlePage('/product/mark')}>演进1号位</div>
                {/*<div className={`nav-list-block ${location.pathname === '/product/plan' ? 'active' : ''}`} onClick={() => handlePage('/product/plan')}>年度学习赋能计划</div>*/}
              </div>
            </Col>
            <Col md={9} className='nav-col'>
              <div className={`nav-title ${location.pathname === '/product/party' ? 'active' : ''}`} onClick={() => handlePage('/product/party')}>党业融合</div>
              <div className='nav-desc'>以高质量党建赋能企业高质量发展</div>
              <div className='nav-list'>
                <div className={`nav-list-block ${location.pathname === '/product/counseling' ? 'active' : ''}`} onClick={() => handlePage('/product/counseling')}>红擎铸魂｜党建全案咨询</div>
                <div className={`nav-list-block ${location.pathname === '/product/cultivate' ? 'active' : ''}`} onClick={() => handlePage('/product/cultivate')}>红擎育锋｜关键人才培育</div>
                <div className={`nav-list-block ${location.pathname === '/product/practice' ? 'active' : ''}`} onClick={() => handlePage('/product/practice')}>红擎践学｜红色教育实践</div>
                {/*<div className={`nav-list-block ${location.pathname === '/product/study/1' ? 'active' : ''}`} onClick={() => handlePage('/product/study/1')}>红色主题研学</div>*/}
              </div>
            </Col>
          </Row>
        </div>
      }
    >
      {children}
    </Dropdown>
  )
}

export default NavbarModel